import React, { useContext, useEffect } from 'react';
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom';
import Admin from './Admin';
import Home from './Home';
import WhatsNew from './WhatsNew';
import NavBar, { NavBarItems } from './NavBar';
import { Col, Container, Row } from 'reactstrap';
import { Store } from './Store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { loadGroupAction } from './Actions';
import Loader from 'react-loader-spinner';
import { loadSetting } from './components/TabsUserSetting';
import WebSocks from './WebSocks';
import { useAuthentication } from './authentication/authentication-hook';
import LoggedOut from './LoggedOut';
import { AuthenticationGuard } from './authentication/AuthenticationGuard';

if (window.location.search) {
    // stash any query string in local storage in case the auth process loses this info
    localStorage.querystring = window.location.search;
    window.location.search = '';
}

function App() {
    useEffect(() => {
        /* STOLEN - https://cameronjonesweb.com.au/blog/fix-google-maps-including-overriding-roboto-fonts/
         * the Google map rather unhelpfully re-imports the Roboto font with different weights, which makes
         * every bold element on the page more chunky! */
        var head = document.getElementsByTagName('head')[0];
        var insertBefore = head.insertBefore;

        head.insertBefore = function (newElement, referenceElement) {
            if (newElement.href && newElement.href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0) {
                return;
            }
            insertBefore.call(head, newElement, referenceElement);
        };
    }, []);

    /**
     * This reacts to all workorder entities
     * - this is at the app root so can make global updates
     *
     * @param {*} data
     */
    const onMessage = data => {
        // check message contents and react accordingly
    };

    document.body.style.backgroundColor = '#f4f4f4';

    return (
        <BrowserRouter>
            <WebSocks onMessage={ onMessage } />
            <ToastContainer />
            <Container
                fluid={ true }
                className="p-0"
            >
                <NavBar>
                    <NavBarItems />
                </NavBar>
                <Switch>
                    <Route
                        path="/"
                        exact
                        render={ (routeProps) => (
                            <AuthenticationGuard>
                                <GroupContainer>
                                    <Home />
                                </GroupContainer>
                            </AuthenticationGuard>)
                        }
                    />
                    <Route
                        path="/admin"
                        exact
                        render={ (routeProps) =>
                            <AuthenticationGuard>
                                <GroupContainer>
                                    <Admin />
                                </GroupContainer>
                            </AuthenticationGuard> }
                    />
                    <Route
                        path="/whatsnew"
                        exact
                        render={ (routeProps) => <WhatsNew { ...routeProps } /> }
                    />
                    <Route
                        path={ '/logout' }
                        exact
                        component={ LoggedOut }
                    />
                    <Route render={ () => 'Not found' } />
                </Switch>
            </Container>
        </BrowserRouter>);
}

function GroupContainer({ children }) {
    const {
        user,
        isAuthenticated,
    } = useAuthentication();

    const {
        dispatch,
        state: {
            groups,
            currentGroup,
            fieldWorkers,
            properties,
            workOrderSubStatuses,
            vatRates,
            cleaners,
        },
    } = useContext(Store);

    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }

        const groupId = Number(loadSetting(user, 'PMSGroup', '1'));
        if (!groupId || Number.isNaN(groupId)) {
            throw new Error('User has invalid groupId');
        }

        loadGroupAction(groupId, dispatch);
    }, [ user?.id, dispatch ]);

    if (!currentGroup) {
        return null;
    }

    if (
        !groups ||
        !currentGroup ||
        !fieldWorkers ||
        !properties ||
        !workOrderSubStatuses ||
        !vatRates ||
        !cleaners
    ) {
        return (
            <React.Fragment>
                <Container>
                    <Row
                        style={ {
                            marginTop: '40px',
                            marginBottom: '40px',
                        } }
                        className="text-center"
                    >
                        <Col>
                            <Loader
                                type="TailSpin"
                                color="#fd6413"
                                height={ 100 }
                                width={ 100 }
                            />
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col>
                            <p>loading statuses...{ workOrderSubStatuses ? ' done' : '' }</p>
                            <p>loading properties...{ properties ? ' done' : '' }</p>
                            <p>loading field workers...{ fieldWorkers ? ' done' : '' }</p>
                            <p>loading cleaners...{ cleaners ? ' done' : '' }</p>
                        </Col>
                    </Row>
                </Container>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            { children }
        </React.Fragment>
    );
}

export default App;
